import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Navigation } from './ErreurFonctionnelle.navigation';
import { HeadingProvider } from '../../context';
import { Headings } from '../../styles';
import {
    hideLoading,
    sendEvent,
    EVENT_CATEGORIES,
    EVENT_ACTIONS,
    EVENT_LABELS
} from './../../features';
import { ErreurFonctionnelleGenerique } from './ErreurFonctionnelleGenerique/ErreurFonctionnelleGenerique';
import { prepareDiagnosticData, useRapportApi } from '../../hooks';
import { AxiosError } from 'axios';
import { ErreurFonctionnelleCustom } from './ErreurFonctionnelleCustom/ErreurFonctionnelleCustom';

const headingMapping = {
    h1: Headings.h3
};

export enum CODE_ERREUR_FONCTIONNELLE_RHN {
    ERREUR_CALCUL_OFFRE = 'CALCUL_OFFRE',
    ERREUR_PAIEMENT_EN_ATTENTE = 'PAIEMENT_EN_ATTENTE'
}

interface IErreurFonctionnelleConnected {
    status?: number;
    isConseiller?: boolean;
    codeErreurRHN?: string;
    messageErreur?: string;
    axiosError?: AxiosError<any>;
    versionTexteErreurPaiementEnAttente?: string;
    revenirJourSemaineErreurPaiementEnAttente?: string;
}

export const ErreurFonctionnelleConnected: React.FC<
    IErreurFonctionnelleConnected
> = ({
    status,
    isConseiller = false,
    codeErreurRHN,
    messageErreur,
    axiosError,
    versionTexteErreurPaiementEnAttente,
    revenirJourSemaineErreurPaiementEnAttente
}) => {
    const dispatch = useDispatch();
    const [t] = useTranslation(['ErreurFonctionnelle']);

    // Store
    const renouvellementData = useSelector(
        (state: any) => state.renouvellement.renouvellementData
    );
    const sessionData = useSelector(
        (state: any) => state.renouvellement.sessionData
    );
    const flowData = useSelector((state: any) => state.renouvellement.flowData);

    useEffect(() => {
        dispatch(hideLoading());

        if (
            codeErreurRHN === CODE_ERREUR_FONCTIONNELLE_RHN.ERREUR_CALCUL_OFFRE
        ) {
            dispatch(
                sendEvent({
                    category: EVENT_CATEGORIES.FORMULAIRE,
                    action: EVENT_ACTIONS.ERREUR_TECHNIQUE,
                    label: EVENT_LABELS.FRM,
                    messageErreur: codeErreurRHN + ' | ' + messageErreur
                })
            );
        } else if (
            codeErreurRHN ===
            CODE_ERREUR_FONCTIONNELLE_RHN.ERREUR_PAIEMENT_EN_ATTENTE
        ) {
            dispatch(
                sendEvent({
                    category: EVENT_CATEGORIES.FORMULAIRE,
                    action: EVENT_ACTIONS.ERREUR_TECHNIQUE,
                    label: EVENT_LABELS.FRM,
                    messageErreur: messageErreur
                })
            );
        } else {
            dispatch(
                sendEvent({
                    category: EVENT_CATEGORIES.FORMULAIRE,
                    action: EVENT_ACTIONS.ERREUR_TECHNIQUE,
                    label: EVENT_LABELS.FRM,
                    messageErreur: status
                        ? status
                        : isConseiller
                        ? t('errorFonctionnelleTextConseiller')
                        : t('errorFonctionnelleText')
                })
            );

            //Try to send report data
            const diagnosticData = prepareDiagnosticData(
                sessionData,
                renouvellementData,
                flowData,
                axiosError?.config?.url,
                axiosError?.response?.data?.errors,
                codeErreurRHN,
                messageErreur
            );
            useRapportApi(diagnosticData);
        }
    }, []);

    return (
        <HeadingProvider value={headingMapping}>
            {codeErreurRHN ===
                CODE_ERREUR_FONCTIONNELLE_RHN.ERREUR_CALCUL_OFFRE ||
            codeErreurRHN ===
                CODE_ERREUR_FONCTIONNELLE_RHN.ERREUR_PAIEMENT_EN_ATTENTE ? (
                <ErreurFonctionnelleCustom
                    codeErreurRHN={codeErreurRHN}
                    versionTexteErreurPaiementEnAttente={
                        versionTexteErreurPaiementEnAttente
                    }
                    revenirJourSemaineErreurPaiementEnAttente={
                        revenirJourSemaineErreurPaiementEnAttente
                    }
                />
            ) : (
                <ErreurFonctionnelleGenerique isConseiller={isConseiller} />
            )}
            <Navigation />
        </HeadingProvider>
    );
};
